import clsx from 'clsx';
import React from 'react';

import { AppConfigType } from '../AppList/AppList';
import Card from '../Elements/Card/Card';

const getButtonLabel = (isConnected: boolean) => {
  return isConnected ? 'Disconnect' : 'Connect';
};

export type AppCardProps = {
  appConfig: AppConfigType;
  isConnected: boolean;
  onConnect: () => void;
  showConnectButton?: boolean;
  onDisconnect?: () => void;
  children?: React.ReactNode;
};

const AppCard = ({
  appConfig,
  onConnect,
  isConnected,
  onDisconnect = null,
  showConnectButton = true,
  children = null,
}: AppCardProps) => {
  const buttonLabel = getButtonLabel(isConnected);
  const handleConnectClick = isConnected ? onDisconnect : onConnect;

  return (
    <React.Fragment>
      <Card>
        <div className="apps-card-header">
          <div className="app-title">
            <div className="logoContainer" style={{ backgroundImage: appConfig.css.image }}></div>
            <p> {appConfig.name}</p>
          </div>
          <div className="action-buttons">
            {showConnectButton && (
              <button
                type="button"
                className={clsx(isConnected && 'active')}
                onClick={handleConnectClick}
              >
                {buttonLabel}
              </button>
            )}
          </div>
        </div>
        <div className="">{children}</div>
      </Card>
    </React.Fragment>
  );
};

export default AppCard;
